import React from "react";
import { node, string } from "prop-types";
import { Stack, Typography, Box } from "@mui/material";

const ButtonGroup = ({ children = null, groupTitle = "" }) => {
  return (
    <Box
      sx={{
        marginBottom: "1.2rem",
        padding: "0 0.7rem",
      }}
    >
      <Typography
        sx={{
          fontSize: "1.4rem",
          marginBottom: "0.4rem",
        }}
      >
        {groupTitle}
      </Typography>
      <Stack
        direction="row"
        spacing={3}
        sx={{
          flexWrap: "wrap",
          gap: 3,
        }}
      >
        {React.Children.map(children, (child, index) => (
          <Box
            key={index}
            sx={{
              flex: 1,
              minWidth: 0,
            }}
          >
            {child}
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

ButtonGroup.propTypes = {
  children: node,
  groupTitle: string,
};

export default ButtonGroup;
